import { composeValidators, maxLength, minLength, required } from '../../validators'
import { LEGACY_MIN_PW_LENGTH, MAX_PW_LENGTH, MIN_PW_LENGTH } from '../../validators/constants'

export const opPasswordValidator = (isLegacy: boolean) => {
	const minLengthValue = isLegacy ? LEGACY_MIN_PW_LENGTH : MIN_PW_LENGTH
	const invalidLengthError = `error_strings.${isLegacy ? 'invalid_legacy_password' : 'invalid_password'}`

	return composeValidators(
		required('error_strings.empty_password'),
		minLength(invalidLengthError, minLengthValue),
		maxLength(invalidLengthError, MAX_PW_LENGTH),
	)
}
